/*
 * @Description: 公共 js
 * @Author: PF
 * @Date: 2022-11-14 18:22:48
 * @LastEditors: PF
 * @LastEditTime: 2026-08-18 11:59:22
 */
// 路由、vuex 开始
import { useRouter } from 'vue-router'
const router = useRouter()
// 路由、vuex 结束

// 右键菜单关闭标签 [id]右键点击ID [type]右键菜单类型
export function youJianCaiDanGuanBiGiaoQian (id, type, callback) {
  const xtList = JSON.parse(sessionStorage.getItem('SET_SYSTEM_LIST'))
  const xtInd = xtList.findIndex((item) => item.id === sessionStorage.getItem('CURRENT_SYSTEM_ID'))
  const cdInfo = xtList[xtInd].children.find((item) => item.id === id)
  const cdInd = xtList[xtInd].children.findIndex((item) => item.id === id)
  switch (type) {
    case '左侧':
      xtList[xtInd].children.splice(1, cdInd - 1)
      break
    case '右侧':
      xtList[xtInd].children.splice(cdInd, 1)
      break
    case '其他':
      // eslint-disable-next-line no-case-declarations
      xtList[xtInd].children = xtList[xtInd].children.filter((_, index) => [0, cdInd].includes(index))
      break
    case '全部':
      xtList[xtInd].children = xtList[xtInd].children.filter((_, index) => [0].includes(index))
      sessionStorage.setItem('menuId', sessionStorage.getItem('CURRENT_SYSTEM_ID'))
      sessionStorage.setItem('menuName', '首页')
      break
  }
  console.log('xtList', xtList[xtInd].children)
  sessionStorage.setItem('SET_SYSTEM_LIST', JSON.stringify(xtList))
  if (callback) {
    console.log(callback)
    // eslint-disable-next-line node/no-callback-literal
    callback(cdInfo)
  }
}
/**
 * 当前日期
 * @param {*} year YYYY
 * @param {*} month MM
 * @param {*} day DD
 * @param {*} hours HH
 * @param {*} minutes mm
 * @param {*} seconds ss
 * @returns getDate(null, 'MM', 'DD', null, null, null) 如只显示后面内容，前面必须有占位
 * @returns getDate('YYYY', 'MM', 'DD', 'HH', 'mm', 'ss') 完整版
 */
export function getDate (year, month, day, hours, minutes, seconds) {
  const now = new Date()
  year = year ? now.getFullYear() : undefined // 得到年份
  month = month ? now.getMonth() + 1 : undefined // 得到月份
  day = day ? now.getDate() : undefined // 得到日期
  hours = hours ? now.getHours() : undefined // 得到时
  minutes = minutes ? now.getMinutes() : undefined // 得到分
  seconds = seconds ? now.getSeconds() : undefined // 得到秒

  day = day < 10 ? '0' + day : day
  month = month < 10 ? '0' + month : month
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds

  const newData = (year || '') + (year && month ? '-' : '') + (month || '') + (month && day ? '-' : '') + (day || '') + (day && hours ? ' ' : '') + (hours || '') + (hours && minutes ? ':' : '') + (minutes || '') + (minutes && seconds ? ':' : '') + (seconds || '')
  const defaultDate = `${newData}`
  return defaultDate
}

// 浮点型相加
export function accAdd (arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 阿拉伯数字转中文数字
export function toChinesNum (num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万', '亿']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    const newArr = []
    strArr.forEach((item, index) => {
      newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
    })
    const numArr = []
    newArr.forEach((m, n) => {
      if (m !== '零') numArr.push(n)
    })
    if (newArr.length > 1) {
      newArr.forEach((m, n) => {
        if (newArr[newArr.length - 1] === '零') {
          if (n <= numArr[numArr.length - 1]) {
            newNum += m
          }
        } else {
          newNum += m
        }
      })
    } else {
      newNum = newArr[0]
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) {
    noWan = '0' + noWan
  }
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

// 日期转为简体中文
export function getZhongWenRiQi (dataStr, val) {
  const dict = { 0: '〇', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '七', 8: '八', 9: '九', 10: '十', 11: '十一', 12: '十二', 13: '十三', 14: '十四', 15: '十五', 16: '十六', 17: '十七', 18: '十八', 19: '十九', 20: '二十', 21: '二十一', 22: '二十二', 23: '二十三', 24: '二十四', 25: '二十五', 26: '二十六', 27: '二十七', 28: '二十八', 29: '二十九', 30: '三十', 31: '三十一' }
  const arr = Array.from(String(dataStr), Number)
  console.log(arr)
  let date = ''
  switch (val) {
    case 'nian':
      date = dict[arr[0]] + dict[arr[1]] + dict[arr[2]] + dict[arr[3]]
      break
    case 'yue':
      date = dict['' + Number(dataStr)]
      break
    case 'ri':
      date = dict[dataStr]
      break
  }
  console.log(date)
  return date
}

/**
 * 合并相同数据，导出合并列所需的方法(只适合el-table)
 * @param {Object} data 列表
 * @param {Object} rowspanArray 需要合并的字段['字段名']
 */
export function getRowspanMethod (data, rowspanArray) {
  /**
   * 要合并列的数据
   */
  const rowspanNumObject = {}

  // 初始化 rowspanNumObject
  // eslint-disable-next-line array-callback-return
  rowspanArray.map((item) => {
    rowspanNumObject[item] = new Array(data.length).fill(1, 0, 1).fill(0, 1)
    rowspanNumObject[`${item}-index`] = 0
  })
  // 计算相关的合并信息
  for (let i = 1; i < data.length; i++) {
    // eslint-disable-next-line array-callback-return
    rowspanArray.map((key) => {
      const index = rowspanNumObject[`${key}-index`]
      if (data[i][key] === data[i - 1][key]) {
        rowspanNumObject[key][index]++
      } else {
        rowspanNumObject[`${key}-index`] = i
        rowspanNumObject[key][i] = 1
      }
    })
  }

  // 提供合并的方法并导出
  const spanMethod = function ({ row, column, rowIndex, columnIndex }) {
    if (rowspanArray.includes(column.property)) {
      const rowspan = rowspanNumObject[column.property][rowIndex]
      if (rowspan > 0) {
        return { rowspan: rowspan, colspan: 1 }
      }
      return { rowspan: 0, colspan: 0 }
    }
    return { rowspan: 1, colspan: 1 }
  }

  return spanMethod
}

// 指定范围随机数
export function getRndInteger (min, max) {
  const fRound = Math.floor(Math.random() * (max - min + 1) + min)
  return fRound
}

// 表头部重新渲染
export function renderHeader ({ column, $index }) {
  // 新建一个 span
  const span = document.createElement('span')
  // 设置表头名称
  span.innerText = column.label
  // 临时插入 document
  document.body.appendChild(span)
  // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
  column.minWidth = span.getBoundingClientRect().width + 20
  // 移除 document 中临时的 span
  document.body.removeChild(span)
  return column.label
}

/**
 * 获取出生日期与性别
 * @param {String} idCard 身份证号
 * @returns {Object}
 */
export function getBirth (idCard) {
  const obj = {
    birthday: '',
    csrq: '', // 出生日期
    xb: '' // 性别
  }
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      obj.birthday = '19' + idCard.slice(6, 12)
    } else if (idCard.length === 18) {
      obj.birthday = idCard.slice(6, 14)
    }
    obj.csrq = obj.birthday.replace(/(.{4})(.{2})/, '$1-$2-')
  }
  if (parseInt(idCard.slice(-2, -1)) % 2 === 1) {
    obj.xb = '男'
  } else {
    obj.xb = '女'
  }
  return obj
}

/**
 * px转mm
 * @param {*} px
 * @returns
 * const pxValue = 100
 * const mmValue = pxToMm(pxValue)
 * console.log(mmValue)
 */
export function pxToMm (px) {
  // 获取屏幕的DPI或设备的分辨率
  const dpi = window.devicePixelRatio * 96
  const mm = px * 25.4 / dpi
  return mm.toFixed(2)
}

/**
 * mm转px
 * @param {*} mm
 * @returns
 * const mmValue = 10; // 要转换的毫米值
 * const pxValue = mmToPx(mmValue);
 * console.log(pxValue); // 输出转换后的像素值
 */
export function mmToPx (mm) {
  const dpi = window.devicePixelRatio
  const inch = mm / 25.4
  const px = inch * dpi
  return px
}

/**
 * 多维数组扁平化
 * @param {Array} tree
 * @returns
 */
export function flattening (tree) {
  const tempArr = []
  tree.forEach(element => {
    tempArr.push(element)
    // 递归
    if (element.children) {
      tempArr.push(...flattening(element.children))
    }
  })
  return tempArr
}

// 判断是否为json格式
export function isValidJSONObject (str) {
  try {
    const obj = JSON.parse(str)
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj)
  } catch (e) {
    return false
  }
}
